import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useScroll } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRIMARY_CTA_ID } from '../data/checkout';
export function DossierActionBar() {
  const {
    scrollY
  } = useScroll();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const unsubscribe = scrollY.on('change', value => setVisible(value > 420));
    return () => unsubscribe();
  }, [scrollY]);
  return <AnimatePresence data-id="element-129" data-mp="1xc9qjnqs8p1n">
      {visible ? <motion.aside aria-label="Resumen del expediente" initial={{
      y: 110,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 110,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gold/25 bg-[linear-gradient(180deg,rgba(18,18,22,0.75),rgba(10,10,13,0.98)_45%)] backdrop-blur-md lg:left-[248px]" data-id="element-130" data-mp="1xenmdytae5a9">
          <div className="mx-auto flex max-w-[1200px] items-center gap-3 px-4 py-2.5 sm:gap-6 sm:px-5 sm:py-3" data-id="element-131" data-mp="93g1umc797s5">
            <div className="flex-shrink-0" data-id="element-132" data-mp="e3lplrfcma4y">
              <p className="hidden font-mono text-[8.5px] uppercase tracking-[0.16em] text-white/35 sm:block" data-id="element-133" data-mp="e0g22gmdbgbc">
                05 · Precio
              </p>
              <div className="flex items-baseline gap-1.5 sm:gap-2" data-id="element-134" data-mp="52xasui4s5r0">
                <span className="text-[11px] text-white/35 line-through sm:text-xs" data-id="element-135" data-mp="sr6thnk1sddx">
                  $47
                </span>
                <span className="font-display text-xl font-extrabold text-gold sm:text-2xl" data-id="element-136" data-mp="ws0hsi1eju7c">
                  $11.99
                </span>
              </div>
            </div>

            <div className="hidden items-center gap-2.5 border-l border-white/10 pl-6 lg:flex" data-id="element-137" data-mp="o06u8bnghj89">
              <ShieldCheck aria-hidden="true" className="h-5 w-5 flex-shrink-0 text-gold" data-id="element-138" data-mp="1bqavwdh338wm" />
              <p className="max-w-[16rem] text-[11.5px] leading-snug text-ash" data-id="element-139" data-mp="1gilyxp74fate">
                Garantía cero riesgo — 7 días, te devolvemos cada centavo.
              </p>
            </div>

            <div className="ml-auto min-w-0 flex-1 sm:flex-none" data-id="element-140" data-mp="1lepyo09yqdfa">
              <CtaButton size="md" href={`#${PRIMARY_CTA_ID}`} className="w-full" data-id="element-141" data-mp="1geamhc1f3byw">
                <span className="sm:hidden" data-id="element-142" data-mp="1bi3gjj90u0gy">Quiero acceso — $11.99</span>
                <span className="hidden sm:inline" data-id="element-143" data-mp="17f73e8292wke">
                  Sí, quiero disrupción visual ahora — $11.99
                </span>
              </CtaButton>
            </div>
          </div>
        </motion.aside> : null}
    </AnimatePresence>;
}